import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

import { SystemPromptVersion } from '../../../types/admin';

interface PromptVersionListProps {
  versions: SystemPromptVersion[];
  activeVersion: number | null;
  selectedVersion: number | null;
  onSelect: (version: number) => void;
}

export const PromptVersionList: React.FC<PromptVersionListProps> = ({
  versions,
  activeVersion,
  selectedVersion,
  onSelect,
}) => (
  <Box className="max-h-[60vh] space-y-2 overflow-auto pr-1">
    {versions.map((item) => {
      const selected = item.version === selectedVersion;
      return (
        <Box
          key={item.publicId}
          role="button"
          tabIndex={0}
          onClick={() => onSelect(item.version)}
          onKeyDown={(e) => e.key === 'Enter' && onSelect(item.version)}
          className={`cursor-pointer rounded-lg border p-3 ${
            selected
              ? 'border-blue-500 bg-blue-50 dark:bg-slate-700'
              : 'border-slate-200 hover:bg-slate-50 dark:border-slate-700 dark:hover:bg-slate-800'
          }`}
        >
          <Box className="flex flex-wrap items-center gap-2">
            <Typography variant="subtitle2" className="text-gray-900 dark:text-slate-100">
              v{item.version}
            </Typography>
            {item.version === activeVersion && <Chip label="Active" size="small" color="success" />}
            {activeVersion !== null && item.version > activeVersion && (
              <Chip label="Pending" size="small" color="warning" />
            )}
            <Chip label={item.source} size="small" variant="outlined" />
          </Box>
          <Typography variant="caption" className="block text-slate-500 dark:text-slate-400">
            {new Date(item.createdAt).toLocaleString()}
          </Typography>
          {item.note && (
            <Typography variant="caption" className="block text-slate-600 dark:text-slate-300">
              {item.note}
            </Typography>
          )}
        </Box>
      );
    })}
  </Box>
);
